export default class MathHelpers {
  static roundNumberWithPrecision(number: number, decimalPlaces: number = 2) {
    const factorOfTen = Math.pow(10, decimalPlaces);

    return Math.round(number * factorOfTen) / factorOfTen;
  }
}
